export default "__VITE_ASSET__DZq81pWh__"